import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 5.5rem);

  .content-os {
    width: 100%;
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 1.3rem;
  padding: 0.8rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-height: 8.2rem;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  background: ${Colors.Color1};

  ${props => {
    if (props?.ativo) {
      return `border: 0.1rem solid ${Colors.Color8};`;
    }
  }}

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .content-top {
      display: flex;
      flex-direction: column;

      .card-cod {
        background: ${Colors.Color8};
        border-radius: 0.4rem;
        padding: 0.2rem 0.6rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 4rem;

        .cod {
          font-size: 0.7rem;
          font-weight: bold;
          color: ${Colors.Color4};
        }
      }

      .card-top {
        margin-top: 0.5rem;
        line-height: 0.9rem;

        .titulo {
          font-size: 0.8rem;
          font-weight: bold;
          color: ${Colors.Color14};
        }

        .analista {
          font-size: 0.7rem;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .data {
        font-size: 0.65rem;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .projeto {
        font-size: 0.65rem;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .cliente {
        font-size: 0.65rem;
        font-weight: 600;
        color: ${Colors.Color14};
      }
    }
  }

  .content-os {
    margin-top: 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .horario {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .item-hora {
        display: flex;
        margin-bottom: 0.2em;

        .card-numero {
          background: ${Colors.Color4};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          width: 1.4em;
          height: 1.4em;
          justify-content: center;
          align-items: center;
          margin-left: 0.45em;

          .numero {
            font-size: 0.7em;
            font-weight: 600;
            color: white;
          }
        }

        .card-hora {
          background: ${Colors.Color8};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          height: 1.4em;
          margin-left: 0.45em;
          justify-content: center;
          align-items: center;

          .hora {
            font-size: 0.7em;
            font-weight: 600;
            color: ${Colors.Color4};
            width: 100%;
          }
        }
      }
    }

    .totalizadores {
      display: flex;
      align-items: flex-start;
      gap: 0.5em;
      margin-left: 1em;

      .desconto,
      .translado,
      .total {
        white-space: nowrap;
      }

      .desconto {
        padding: 0.2em 0.6em;
        font-size: 0.8em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .translado {
        padding: 0.2em 0.6em;
        font-size: 0.8em;
        font-weight: 600;
        margin-left: 1em;
        color: ${Colors.Color14};
      }

      .card-total {
        background: ${Colors.Color8};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        /* height: 1.4em; */
        justify-content: center;
        align-items: center;

        .total {
          font-size: 0.75em;
          font-weight: bold;
          color: ${Colors.Color4};
          width: 100%;
        }
      }
    }
  }
`;

export const ThisCalendar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 24rem;

  .calendario {
    display: flex;
    flex-direction: column;
    align-items: center;

    select {
      width: 17rem;
      margin-bottom: 2rem;
    }

    .meses {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;

      .mes {
        background: ${Colors.Color4};
        border-radius: 0.9rem;
        padding: 0.2rem 0.6rem;
        display: flex;
        flex-direction: column;
        width: 3.5rem;
        height: 3.8rem;
        justify-content: center;
        align-items: center;
        margin-left: 0.45rem;
        margin-right: 0.45rem;
        margin-bottom: 0.45rem;
        cursor: pointer;

        .titulo-mes {
          font-size: 0.9rem;
          font-weight: 600;
          color: white;
        }

        .ano {
          font-size: 0.75rem;
          color: white;
        }
      }

      .mes-desativo {
        border-radius: 1rem;
        padding: 0.2rem 0.6rem;
        display: flex;
        flex-direction: column;
        width: 3.5rem;
        height: 3.8rem;
        justify-content: center;
        align-items: center;
        margin-left: 0.45rem;
        margin-right: 0.45rem;
        margin-bottom: 0.45rem;
        cursor: pointer;

        .titulo-mes {
          font-size: 0.9rem;
          font-weight: 600;
          color: ${Colors.Color14};
        }

        .ano {
          font-size: 0.75rem;
          color: ${Colors.Color14};
        }
      }
    }
  }
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;
`;
